import { z } from 'zod';
import { postQuestInputSchema, postQuestOutputSchema } from '@zealy/utils';
export const createQuestInputSchema = postQuestInputSchema;
export const createQuestOutputSchema = postQuestOutputSchema;
export const createQuestQuerySchema = z.object({
    generated: z.literal('true').optional(),
});
